import { Link } from '@mantine/tiptap';
import { MAIL_DEFS, type MailKind } from '@reditelji/shared';
import StarterKit from '@tiptap/starter-kit';
import { BlockPlaceholder, CtaButton, InlinePlaceholder } from './nodes';

/**
 * Everything the mail body editor understands.
 *
 * Rich text is deliberately narrow — bold, italic, two heading levels, lists,
 * links, a rule and one button — because everything here has to survive mail
 * clients that ignore stylesheets. What the screen is actually about is the
 * placeholders, so they get the chips and the palette.
 *
 * A factory rather than a constant: Tiptap hangs per-editor storage off the
 * extension objects, so an editor gets its own set. It also lets a test build
 * the real schema without going through React.
 *
 * It takes the kind of mail because a button's own editor has to know whether
 * this mail carries ⟦povezava⟧ — the same thing the toolbar's insert dialog
 * knows — and because a mail without buttons (an obvestilo) has no button node
 * at all: a pasted `<a data-cta>` then reads as the ordinary link it points to.
 */
export const mailExtensions = (templateKey: MailKind) => [
  StarterKit.configure({
    link: false,
    // Mail clients render neither, and both invite pasted formatting that
    // would not survive the trip.
    codeBlock: false,
    blockquote: false,
  }),
  Link.configure({ openOnClick: false }),
  InlinePlaceholder,
  BlockPlaceholder,
  ...(MAIL_DEFS[templateKey].buttons
    ? [CtaButton.configure({ allowsPovezava: MAIL_DEFS[templateKey].allows.includes('povezava') })]
    : []),
];
